<template>
  <section class="article">
      <div class="container">
          <div class="row">
              <div class="col-12 head">
                  <h2 class="title">{{ $t('contact.title') }}</h2>
              </div>
          </div>
          <div class="row text-justify pt-4">
              <div class="col-12 col-md-4 pb-4">
                  <div class="row">
                    <div class="col-auto contact-bullet d-flex align-items-center">
                      <img src="../assets/img/info-solid.svg" fill="red" alt="" class="img-fluid">
                    </div>
                    <div class="col contact-content">
                      Genomed S.A.<br />
                      ul. Ponczowa 12<br />
                      02-971 Warszawa 
                    </div>
                  </div>
              </div>
              <div class="col-12 col-md-4 pb-4">
                  <div class="row">
                    <div class="col-auto contact-bullet d-flex align-items-center">
                      <img src="../assets/img/envelope-solid.svg" fill="red" alt="" class="img-fluid">
                    </div>
                    <div class="col contact-content">
                      <a href="mailto:genom23@genomed.pl">genom23@genomed.pl</a>
                    </div>
                  </div>
              </div>
              <div class="col-12 col-md-4 pb-4">
                  <div class="row">
                    <div class="col-auto contact-bullet d-flex align-items-center">
                      <img src="../assets/img/phone-solid.svg" fill="red" alt="" class="img-fluid">
                    </div>
                    <div class="col contact-content">
                      <a href="tel:48226446019 ">+48 22 644 60 19</a>
                    </div>
                  </div>
              </div>
          </div>
          <div class="row embed-map">
            <div class="col p-3">
              <iframe scrolling="no" marginheight="0" marginwidth="0" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d156533.18596950293!2d20.843105626460996!3d52.19194400298763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47192dad140137f1%3A0x36f0c5d7c1e0e40e!2sGenomed%20S.A.%20-%20Diagnostyka%20i%20Badania%20Genetyczne!5e0!3m2!1spl!2spl!4v1707480689649!5m2!1spl!2spl" title="Genomed" aria-label="Genomed" frameborder="0"></iframe>
            </div>
          </div>
      </div>
  </section>
</template>

<script>
    export default {
        name: "Contact"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Contact.vue